import { Component, ChangeDetectionStrategy, Output, EventEmitter, ChangeDetectorRef, ViewRef, HostListener } from '@angular/core';
import { PivotSave } from '../../models/pivotsave';

@Component({
  selector: 'mdg-save',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // templateUrl: 'MDG.Save.html',
  template: `<div *ngIf="showSaveOption" class='mdg-filter-container'>
  <div class="mdg-filter-popup-container">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <h3>Save Pivot Report</h3>
      </div>
    </div>
    <hr class="buffer-5-0">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <label>Format Name : </label>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <input class="form-control no-radius" [(ngModel)]='data.formatName' maxlength="150">
      </div>
    </div>
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <label>Report Title : </label>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <input class="form-control no-radius" [(ngModel)]='data.reportTitle' maxlength="150">
      </div>
    </div>
    <div class='row'>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Show Option :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.showOptions'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Show Filter :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.showFilter'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Show Additional Filter :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.showAdditionalFilter'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Show Column Filter :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.showColumnFilter'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Show Format :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.showFormat'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Show Save :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.showSave'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Show Export :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.showExport'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Show Print :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.showPrint'>
        </label>
      </div>
    </div>
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <h3>Pivot Formats</h3>
      </div>
    </div>
    <hr class="buffer-5-0">
    <div class='row'>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Line Chart :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.lineChart'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Bar Chart :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.barChart'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Doughnut Chart :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.doughnutChart'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Radar Chart :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.radarChart'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Pie Chart :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.pieChart'>
        </label>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 padding-top-bottom-10">
        <label>Polar Area Chart :
          <input type="checkbox" class="no-radius" [(ngModel)]='data.polarAreaChart'>
        </label>
      </div>
    </div>
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-xs-12 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='SaveReport()'>Save</button>
            <button class='btn btn-sm btn-default' (click)='showSaveOption = false'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
})
export class MDGSaveComponent {

  @Output() saveReport: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveError: EventEmitter<any> = new EventEmitter<any>();

  showSaveOption: boolean = false;
  data: PivotSave;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showSaveOption) {
      this.showSaveOption = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef) { }

  ShowSaveOption(isCustomSave: boolean) {
    this.data = new PivotSave();
    this.data.formatName = '';
    this.data.reportTitle = '';
    this.data.showExport = true;
    this.data.showFilter = true;
    this.data.showAdditionalFilter = true;
    this.data.showColumnFilter = true;
    this.data.showFormat = true;
    this.data.showOptions = false;
    this.data.showPrint = true;
    this.data.showSave = false;
    this.data.lineChart = true;
    this.data.barChart = true;
    this.data.doughnutChart = true;
    this.data.radarChart = true;
    this.data.pieChart = true;
    this.data.polarAreaChart = true;
    if (isCustomSave) {
      this.data.showOptions = true;
      this.data.showSave = true;
      this.saveReport.emit(this.data);
    } else {
      this.showSaveOption = true;
    }
    this.detectChanges();
  }

  SaveReport() {
    if (this.data.formatName !== undefined && this.data.formatName.trim() !== '') {
      setTimeout(() => {
        this.saveReport.emit(this.data);
      }, 10);
      this.showSaveOption = false;
    } else {
      this.saveError.emit('Please provide format name.');
    }
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
